<template>
  <div class="modifica-utente" v-if="!isFetching">
    <h3 v-if="utente_nuovo">{{ labels.crea_nuovo_utente }}</h3>
    <h3 v-else>{{ labels.modifica_utente }}</h3>
    <br />
    <b-form-row class="b-form-row">
      <b-col sm="12" md="4" lg="4" xl="4">
        <b-form-group v-bind:label="labels.codice">
          <b-form-input
            :size="size"
            class="b-form-input"
            id="codice"
            v-model="utente.codice"
            maxlength="45"
            v-bind:readonly="!utente_nuovo"
          ></b-form-input>
          <p class="errore" id="errore-codice" v-if="isError(errori.codice)">
            {{ labels_errori[errori.codice] }}
          </p>
        </b-form-group>
      </b-col>
      <b-col sm="12" md="8" lg="8" xl="8">
        <b-form-group v-bind:label="labels.descrizione">
          <b-form-input
            :size="size"
            class="b-form-input"
            id="descrizione"
            v-model="utente.descrizione"
            maxlength="250"
          ></b-form-input>
          <p
            class="errore"
            id="errore-descrizione"
            v-if="isError(errori.descrizione)"
          >
            {{ labels_errori[errori.descrizione] }}
          </p>
        </b-form-group>
      </b-col>
    </b-form-row>

    <b-form-row class="b-form-row">
      <b-col sm="12" md="6" lg="3" xl="3">
        <b-form-group class="b-form-group" v-bind:label="labels.password">
          <b-form-input
            :size="size"
            class="b-form-input"
            id="password"
            v-model="utente.password"
            maxlength="255"
            type="password"
            autocomplete="off"
          ></b-form-input>
          <p
            class="errore"
            id="errore-password"
            v-if="isError(errori.password)"
          >
            {{ labels_errori[errori.password] }}
          </p>
        </b-form-group>
      </b-col>
      <b-col sm="12" md="6" lg="3" xl="3">
        <b-form-group
          class="b-form-group"
          v-bind:label="labels.conferma_password"
        >
          <b-form-input
            :size="size"
            class="b-form-input"
            id="conferma-password"
            v-model="conferma_password"
            maxlength="255"
            type="password"
            autocomplete="off"
          ></b-form-input>
          <p
            class="errore"
            id="errore-conferma-password"
            v-if="isError(errori.conferma_password)"
          >
            {{ labels_errori[errori.conferma_password] }}
          </p>
        </b-form-group>
      </b-col>
      <b-col sm="12" md="6" lg="3" xl="3">
        <b-form-group class="b-form-group" v-bind:label="labels.disabilitato">
          <b-form-checkbox
            id="disabilitato"
            v-model="utente.disabilitato"
            name="disabilitato"
            value="S"
            unchecked-value
            >{{ labels.disabilitato }}</b-form-checkbox
          >
          <p
            class="errore"
            id="errore-disabilitato"
            v-if="isError(errori.disabilitato)"
          >
            {{ labels_errori[errori.disabilitato] }}
          </p>
        </b-form-group>
      </b-col>
      <b-col sm="12" md="6" lg="3" xl="3">
        <b-form-group class="b-form-group" v-bind:label="labels.ruolo">
          <b-form-select
            v-model="utente.ruolo"
            :options="valori_ruolo"
            :size="size"
            class="b-form-select"
            id="ruolo"
            maxlength="1"
            :plain="$store.state.SelectPlain"
          ></b-form-select>
          <p class="errore" id="errore-ruolo" v-if="isError(errori.ruolo)">
            {{ labels_errori[errori.ruolo] }}
          </p>
        </b-form-group>
      </b-col>
    </b-form-row>
    <b-form-row class="b-form-row">
      <b-col sm="12" md="8" lg="8" xl="8">
        <b-form-group class="b-form-group" v-bind:label="labels.email">
          <b-form-input
            :size="size"
            class="b-form-input"
            id="email"
            v-model="utente.email"
            maxlength="255"
            type="text"
          ></b-form-input>
          <p class="errore" id="errore-email" v-if="isError(errori.email)">
            {{ labels_errori[errori.email] }}
          </p>
        </b-form-group>
      </b-col>
      <b-col sm="12" md="4" lg="4" xl="4">
        <b-form-group class="b-form-group" v-bind:label="labels.lingua">
          <b-form-select
            v-model="utente.lingua"
            :options="lingue"
            :size="size"
            class="b-form-select"
            id="lingua"
            maxlength="2"
            :plain="$store.state.SelectPlain"
          ></b-form-select>
          <p class="errore" id="errore-lingua" v-if="isError(errori.lingua)">
            {{ labels_errori[errori.lingua] }}
          </p>
        </b-form-group>
      </b-col>
    </b-form-row>
    <br />
    <b-form-row class="b-form-row" style="text-align: center">
      <b-col sm="6" md="6" lg="6" xl="6">
        <b-button variant="warning" @click="ritorna" style="width: 100%">{{
          labels.ritorna_alla_lista
        }}</b-button>
        <div class="errore" id="errore-ritorna" v-if="isError(errori.ritorna)">
          <br />
          {{ labels_errori[errori.ritorna] }}
        </div>
      </b-col>
      <b-col sm="6" md="6" lg="6" xl="6">
        <b-button
          variant="success"
          @click="salva"
          :disabled="invio_in_corso"
          style="width: 100%"
          >{{ labels.salva_modifiche }}</b-button
        >
        <div class="errore" id="errore-salva" v-if="isError(errori.salva)">
          <br />
          {{ labels_errori[errori.salva] }}
        </div>
      </b-col>
    </b-form-row>
    <br />

    <!--
    <b-form-row class="b-form-row" style="text-align:center">
      <b-col sm="12" md="12" lg="12" xl="12">
        <b-alert
          :show="dismissCountDown"
          dismissible
          fade
          variant="warning"
          @dismiss-count-down="countDownChanged"
        >{{ labels.aggiornamento_effettuato }}</b-alert>
      </b-col>
    </b-form-row>
    -->

    <b-form-row
      class="b-form-row"
      style="text-align: center"
      v-if="isError(errori.salva)"
    >
      <b-col sm="12" md="12" lg="12" xl="12">
        <div class="errore" id="errore-salva">
          <br />
          {{ labels_errori[errori.salva] }}
        </div>
      </b-col>
    </b-form-row>
  </div>
</template>

<script>
import router from "@/router/index";
import store from "@/store/index";
import { utility } from "@/utility";
const axios = require("axios");

export default {
  name: "ModificaUtente",
  data() {
    return {
      utente_nuovo: false,
      labels: {},
      labels_errori: {},
      errori: [],
      codice_utente: "",
      utente: {
        codice: "",
        struttura: "",
        descrizione: "",
        password: "",
        disabilitato: "",
        ruolo: "",
        email: "",
        lingua: "",
      },
      conferma_password: "",
      lingue: [
        { value: "IT", text: "IT" },
        { value: "EN", text: "EN" },
        { value: "DE", text: "DE" },
        //        { value: "FR", text: "FR" }
      ],
      valori_ruolo: [],
      size: "sm",
      isFetching: true,
      invio_in_corso: false,
    };
  },
  watch: {
    "$store.state.Lingua"(Lingua) {
      fn_CambiaLingua(Lingua, this);
    },
  },
  components: {},
  mixins: [utility],
  methods: {
    salva() {
      try {
        let me = this;

        if (!fn_ControllaDati(this)) {
          return;
        }

        let ServerURL = this.$store.state.ServerURL;
        let Utente = this.$store.state.Utente;
        let Password = this.$store.state.Password;
        let Struttura = this.$store.state.Struttura;

        let parametri = {
          utente_collegato: Utente,
          password_utente_collegato: Password,
          struttura_utente_collegato: Struttura,
          utente: this.utente,
          utente_nuovo: this.utente_nuovo ? "S" : "N",
        };

        let parametri_json = JSON.stringify(parametri);
        fn_CambiaCursore("wait", this);
        this.invio_in_corso = true;

        axios({
          method: "post",
          url: ServerURL + "CheckIn/SalvaUtente",
          data: parametri_json,
        })
          .then(function (response) {
            me.invio_in_corso = false;
            fn_CambiaCursore("default", me);

            if (me.utente.codice == me.$store.state.Utente) {
              me.$store.commit("SettaLingua", me.utente.lingua);
            }

            if (response.data.errore == 0) {
              me.$root.$children[0].$refs.ApplicationAlert.show(
                me.labels.aggiornamento_effettuato,
                function () {
                  me.$router.push("/amministrazione/gestioneutenti");
                }
              );
            } else if (response.data.errore == -2) {
              me.registraErrore(response.data.esito, "ModificaUtente-salva");
            } else {
              me.$bvModal.msgBoxOk(me.labels_errori[response.data.esito], {
                title: me.labels_errori.si_e_verificato_un_errore,
                bodyClass: "errore",
              });
            }
          })
          .catch(function (error) {
            me.invio_in_corso = false;
            fn_CambiaCursore("default", me);
            me.registraErrore(error, "ModificaUtente-salva");
          });
      } catch (error) {
        this.invio_in_corso = false;
        this.registraErrore(error, "ModificaUtente-salva");
      }
    },
    ritorna() {
      try {
        this.$router.push("/amministrazione/gestioneutenti");
      } catch (error) {
        this.registraErrore(error, "ModificaUtente-ritorna");
      }
    },
  },
  beforeRouteEnter(to, from, next) {
    try {
      let UtenteAutenticato = store.state.UtenteAutenticato;
      let UtenteAmministratore = store.state.UtenteAmministratore;
      if (
        (to.meta.requiresAuth && !UtenteAutenticato) ||
        (to.meta.is_admin && !UtenteAmministratore)
      ) {
        router.push(
          "/amministrazione/permessiinsufficienti",
          null,
          function () {}
        );
      } else {
        next();
      }
    } catch (error) {
      router.push({ name: "Errore", params: { errore: error.stack } });
    }
  },
  created() {
    try {
      fn_CambiaLingua(this.$store.state.Lingua, this);
      let me = this;
      this.codice_utente = this.$route.params.utente;

      if (this.codice_utente == undefined || this.codice_utente.trim() == "") {
        this.utente.codice = "";
        this.utente.struttura = this.$store.state.Struttura;
        this.utente.descrizione = "";
        this.utente.password = "";
        this.utente.disabilitato = "";
        this.utente.ruolo = "N";
        this.utente.email = "";
        this.utente.lingua = this.$store.state.Lingua;
        this.conferma_password = "";

        this.utente_nuovo = true;
        this.isFetching = false;

        return;
      }

      let ServerURL = this.$store.state.ServerURL;
      let Utente = this.$store.state.Utente;
      let Password = this.$store.state.Password;
      let Struttura = this.$store.state.Struttura;

      let parametri = {
        utente_collegato: Utente,
        password_utente_collegato: Password,
        struttura_utente_collegato: Struttura,
        utente: this.codice_utente,
      };

      let parametri_json = JSON.stringify(parametri);

      fn_CambiaCursore("wait", this);

      axios({
        method: "post",
        url: ServerURL + "CheckIn/LeggiUtente",
        data: parametri_json,
      })
        .then(function (response) {
          fn_CambiaCursore("default", me);
          me.utente = response.data.oggetto;
          me.conferma_password = me.utente.password;

          me.isFetching = false;
        })
        .catch(function (error) {
          fn_CambiaCursore("default", me);
          me.registraErrore(error, "ModificaUtente-created");
        });
    } catch (error) {
      this.registraErrore(error, "ModificaUtente-created");
    }
  },
  updated() {
    //this.$nextTick(() => fn_ControllaDati(this));
  },
};

function fn_CambiaLingua(lingua, vm) {
  try {
    let labels_italiano = {
      modifica_utente: "Modifica utente",
      crea_nuovo_utente: "Crea nuovo utente",
      codice: "Codice",
      descrizione: "Descrizione",
      password: "Password",
      conferma_password: "Conferma password",
      disabilitato: "Disabilitato",
      ruolo: "Ruolo",
      email: "Email",
      lingua: "Lingua",
      ritorna_alla_lista: "Ritorna alla lista",
      salva_modifiche: "Salva modifiche",
      aggiornamento_effettuato: "Aggiornamento effettuato",
    };
    let labels_inglese = {
      modifica_utente: "Modifica utente",
      crea_nuovo_utente: "Crea nuovo utente",
      codice: "Codice",
      descrizione: "Descrizione",
      password: "Password",
      conferma_password: "Conferma password",
      disabilitato: "Disabilitato",
      ruolo: "Ruolo",
      email: "Email",
      lingua: "Lingua",
      ritorna_alla_lista: "Ritorna alla lista",
      salva_modifiche: "Salva modifiche",
      aggiornamento_effettuato: "Aggiornamento effettuato",
    };
    let labels_tedesco = {
      modifica_utente: "Modifica utente",
      crea_nuovo_utente: "Crea nuovo utente",
      codice: "Codice",
      descrizione: "Descrizione",
      password: "Password",
      conferma_password: "Conferma password",
      disabilitato: "Disabilitato",
      ruolo: "Ruolo",
      email: "Email",
      lingua: "Lingua",
      ritorna_alla_lista: "Ritorna alla lista",
      salva_modifiche: "Salva modifiche",
      aggiornamento_effettuato: "Aggiornamento effettuato",
    };
    let labels_francese = {
      modifica_utente: "Modifica utente",
      crea_nuovo_utente: "Crea nuovo utente",
      codice: "Codice",
      descrizione: "Descrizione",
      password: "Password",
      conferma_password: "Conferma password",
      disabilitato: "Disabilitato",
      ruolo: "Ruolo",
      email: "Email",
      lingua: "Lingua",
      ritorna_alla_lista: "Ritorna alla lista",
      salva_modifiche: "Salva modifiche",
      aggiornamento_effettuato: "Aggiornamento effettuato",
    };

    let labels_errori_italiano = {
      si_e_verificato_un_errore: "Si è verificato un errore",
      si_sono_verificati_degli_errori: "Si sono verificati degli errori",
      dato_obbligatorio: "Dato obbligatorio",
      indirizzo_email_non_valido: "Indirizzo email non valido",
      password_non_corrispondenti: "Password non corrispondenti",
      utente_non_trovato: "Utente non trovato",
      utente_gia_esistente: "Esiste già un utente con lo stesso codice",
      ultimo_amministratore:
        "Deve esistere almento un utente amministratore abilitato. Modifica non effettuata.",
    };
    let labels_errori_inglese = {
      si_e_verificato_un_errore: "Si è verificato un errore",
      si_sono_verificati_degli_errori: "Si sono verificati degli errori",
      dato_obbligatorio: "Dato obbligatorio",
      indirizzo_email_non_valido: "Indirizzo email non valido",
      password_non_corrispondenti: "Password non corrispondenti",
      utente_non_trovato: "Utente non trovato",
      utente_gia_esistente: "Esiste già un utente con lo stesso codice",
      ultimo_amministratore:
        "Deve esistere almento un utente amministratore abilitato. Modifica non effettuata.",
    };
    let labels_errori_tedesco = {
      si_e_verificato_un_errore: "Si è verificato un errore",
      si_sono_verificati_degli_errori: "Si sono verificati degli errori",
      dato_obbligatorio: "Dato obbligatorio",
      indirizzo_email_non_valido: "Indirizzo email non valido",
      password_non_corrispondenti: "Password non corrispondenti",
      utente_non_trovato: "Utente non trovato",
      utente_gia_esistente: "Esiste già un utente con lo stesso codice",
      ultimo_amministratore:
        "Deve esistere almento un utente amministratore abilitato. Modifica non effettuata.",
    };
    let labels_errori_francese = {
      si_e_verificato_un_errore: "Si è verificato un errore",
      si_sono_verificati_degli_errori: "Si sono verificati degli errori",
      dato_obbligatorio: "Dato obbligatorio",
      indirizzo_email_non_valido: "Indirizzo email non valido",
      password_non_corrispondenti: "Password non corrispondenti",
      utente_non_trovato: "Utente non trovato",
      utente_gia_esistente: "Esiste già un utente con lo stesso codice",
      ultimo_amministratore:
        "Deve esistere almento un utente amministratore abilitato. Modifica non effettuata.",
    };

    let valori_ruolo_italiano = [
      { value: "N", text: "Utente normale" },
      { value: "A", text: "Utente amministratore" },
    ];
    let valori_ruolo_inglese = [
      { value: "N", text: "Utente normale" },
      { value: "A", text: "Utente amministratore" },
    ];
    let valori_ruolo_tedesco = [
      { value: "N", text: "Utente normale" },
      { value: "A", text: "Utente amministratore" },
    ];
    let valori_ruolo_francese = [
      { value: "N", text: "Utente normale" },
      { value: "A", text: "Utente amministratore" },
    ];

    switch (lingua) {
      case "IT":
        vm.labels = labels_italiano;
        vm.labels_errori = labels_errori_italiano;
        vm.valori_ruolo = valori_ruolo_italiano;
        break;
      case "EN":
        vm.labels = labels_inglese;
        vm.labels_errori = labels_errori_inglese;
        vm.valori_ruolo = valori_ruolo_inglese;
        break;
      case "DE":
        vm.labels = labels_tedesco;
        vm.labels_errori = labels_errori_tedesco;
        vm.valori_ruolo = valori_ruolo_tedesco;
        break;
      case "FR":
        vm.labels = labels_francese;
        vm.labels_errori = labels_errori_francese;
        vm.valori_ruolo = valori_ruolo_francese;
        break;
      default:
        vm.labels = labels_inglese;
        vm.labels_errori = labels_errori_inglese;
        vm.valori_ruolo = valori_ruolo_inglese;
        break;
    }
  } catch (error) {
    vm.registraErrore(error, "ModificaUtente-fn_CambiaLingua");
  }
}

function fn_ControllaDati(vm) {
  try {
    let esito = true;

    vm.errori = {};
    if (vm.utente.codice.trim() == "") {
      vm.errori.codice = "dato_obbligatorio";
      esito = false;
    }
    if (vm.utente.descrizione.trim() == "") {
      vm.errori.descrizione = "dato_obbligatorio";
      esito = false;
    }

    if (vm.utente.password.trim() == "") {
      vm.errori.password = "dato_obbligatorio";
      esito = false;
    } else {
      if (vm.utente.password != vm.conferma_password) {
        vm.errori.password = "password_non_corrispondenti";
        esito = false;
      }
    }
    // if (vm.utente.disabilitato.trim() == "") {
    //   vm.utente.disabilitato = "N";
    // } else {
    //   if (
    //     vm.utente.disabilitato.trim().toUpperCase() != "S" &&
    //     vm.utente.disabilitato.trim().toUpperCase() != "N"
    //   ) {
    //     vm.utente.disabilitato = "N";
    //   }
    // }
    if (vm.utente.ruolo.trim() == "") {
      vm.errori.ruolo = "dato_obbligatorio";
      esito = false;
    }

    if (vm.utente.email.trim() == "") {
      vm.errori.email = "dato_obbligatorio";
      esito = false;
    } else {
      let pattern = vm.$store.state.PatternEmail;
      if (!pattern.test(vm.utente.email)) {
        vm.errori.email = "indirizzo_email_non_valido";
        esito = false;
      }
    }
    if (vm.utente.lingua.trim() == "") {
      vm.errori.lingua = "dato_obbligatorio";
      esito = false;
    }

    if (esito) {
      return true;
    } else {
      vm.errori.invia = "si_sono_verificati_degli_errori";
      return false;
    }
  } catch (error) {
    vm.registraErrore(error, "ModificaUtente-fn_ControllaDati");
  }
}
function fn_CambiaCursore(cursore, vm) {
  document.querySelector("body").style.cursor = cursore;

  if (cursore == "wait") {
    vm.invio_in_corso = true;
  } else {
    vm.invio_in_corso = false;
  }
}
</script>

<style scoped>
.modifica-utente {
  border-style: solid;
  border-width: 1px;
  border-color: lightgray;
  border-radius: 4px;
  padding: 20px;
}
</style>
